/* eslint-disable react-hooks/exhaustive-deps */
import { Tooltip } from "@material-ui/core";
import TouchAppIcon from "@material-ui/icons/TouchApp";
import ConfirmPopup from "app/common/Component/Popup/ConfirmPopup";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsRadioButton from "app/common/form/GlobitsRadioButton";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import IconClose from "app/common/Icon/IconClose";
import {
  INTEREST_RATE_TYPE,
  PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT,
  PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT,
  PAYMENT_METHOD_CHARACTERISTIC_LOYALTY,
  PAYMENT_METHOD_CHARACTERISTIC_POS,
  PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP,
  PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT,
  PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE,
  PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD,
  TYPE_GLOBAL_PROPOTIES_BANK,
  TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE,
  TYPE_GLOBAL_PROPOTIES_POS_LIST,
  TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP,
  VOUCHER_INVOICE_TYPE_VALUE,
} from "app/common/LocalConst";
import { PAYMENT_METHOD_CODES_REQUIRED_INTEREST_RATE } from "app/appConfig";
import SelectTreatmentRetainPopup from "app/PatientManagement/PatientGeneral/PatientGeneralTabs/FeeTab/Popup/SelectTreatmentRetainPopup";
import { pagingExtGlobalProperty } from "app/services/GlobalPropertyService";
import { useStore } from "app/stores";
import { getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo } from "react";
import { toast } from "react-toastify";
import SelectCardFeePopup from "../Popup/SelectCardFeePopup";
import SelectDepositMoneyFeePopup from "../Popup/SelectDepositMoneyFeePopup";
import SelectInterestRatePopup from "../Popup/SelectInterestRatePopup";
import SelectLoyaltyPointPopup from "../Popup/SelectLoyaltyPointPopup";

function TotalOfVoucherByUpdate({
  nameSpace,
  moneyAfterDiscount,
  listStk,
  listPos,
  listHomecredit,
  listPos_tragop,
  editable,
  patientId,
}) {
  const { values, setFieldValue, errors } = useFormikContext();

  const withNameSpace = (name, index) => {
    return `${nameSpace}[${index}].${name}`;
  };

  const handleChangeTotalOfMethod = (e, item, index) => {
    let value = e?.target?.value;
    // if (value > moneyAfterDiscount) {
    //   toast.warning("Không được điền số tiền lớn hơn tiền thanh toán");
    //   return;
    // }
    //set value
    setFieldValue(withNameSpace("totalOfMethod", index), value);

    //if methodnot bank :re calculate totalOfMethod
    let newVoucherPaymentMethods =
      voucherPaymentMethods?.length > 0 &&
      voucherPaymentMethods?.map((el, ind) => {
        if (index === ind) return { ...el, totalOfMethod: value };
        else return el;
      });

    let sum =
      newVoucherPaymentMethods?.length > 0 &&
      newVoucherPaymentMethods?.reduce((acc, el) => {
        if (
          el?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
        ) {
          return acc;
        }
        return acc + +el?.totalOfMethod;
      }, 0);

    //if method bank then set stk account bank
    if (
      item?.paymentMethodValue?.characteristic ===
      PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT &&
      !item?.paymentBank
    ) {
      setFieldValue(withNameSpace("paymentBank", index), listStk?.[0]);
    }

    if (
      item?.paymentMethodValue?.characteristic ===
      PAYMENT_METHOD_CHARACTERISTIC_POS &&
      !item?.paymentBank
    ) {
      setFieldValue(withNameSpace("paymentBank", index), listPos?.[0]);
    }

    if (
      item?.paymentMethodValue?.characteristic ===
      PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT &&
      !item?.paymentBank
    ) {
      setFieldValue(withNameSpace("paymentBank", index), listHomecredit?.[0]);
    }
    if (
      item?.paymentMethodValue?.characteristic ===
      PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP &&
      !item?.paymentBank
    ) {
      setFieldValue(withNameSpace("paymentBank", index), listPos_tragop?.[0]);
    }
    voucherPaymentMethods?.forEach((el, indexItem) => {
      if (
        el?.paymentMethodValue?.characteristic ===
        PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
      ) {
        let amountBank = +moneyAfterDiscount - sum;
        setFieldValue(withNameSpace("totalOfMethod", indexItem), amountBank);
        if (amountBank <= 0) {
          setFieldValue(withNameSpace("interestRateType", indexItem), null);
          setFieldValue(withNameSpace("interestRate", indexItem), 0);
          setFieldValue(withNameSpace("periodMonths", indexItem), 0);
          setFieldValue(withNameSpace("interestRatePeriodId", indexItem), null);
        }
      } else if (index === indexItem && +value <= 0) {
        setFieldValue(withNameSpace("interestRateType", indexItem), null);
        setFieldValue(withNameSpace("interestRate", indexItem), 0);
        setFieldValue(withNameSpace("periodMonths", indexItem), 0);
        setFieldValue(withNameSpace("interestRatePeriodId", indexItem), null);
      }
    });
  };

  let voucherPaymentMethods = values?.voucherPaymentMethods;

  if (values?.voucherInvoiceType === VOUCHER_INVOICE_TYPE_VALUE.Refund) {
    voucherPaymentMethods = values?.voucherPaymentMethods?.filter(
      (el) =>
        el?.paymentMethodValue?.characteristic !==
        PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD &&
        el?.paymentMethodValue?.characteristic !==
        PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT
    );
  }

  const handleCheckMoneyHasDepositOrCard = () => {
    return voucherPaymentMethods?.some((elm) => {
      if (
        (elm?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD &&
          elm?.totalOfMethod > 0) ||
        (elm?.paymentMethodValue?.characteristic ===
          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT &&
          elm?.totalOfMethod > 0) ||
        (elm?.paymentMethodValue?.code ===
          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE &&
          elm?.totalOfMethod > 0)
      ) {
        return true;
      }
      return false;
    });
  };

  return (
    <div
      style={{ overflow: "auto", scrollbarWidth: "thin", padding: "0" }}
      className="table-root table-concept-datatype"
    >
      <div style={{ maxHeight: "60vh", padding: "0" }}>
        <table className="table-container table-layout-fixed">
          <thead className="row-table-header">
            <tr>
              <th width="35%" style={{ color: "#4276a4" }}>
                HTTT
              </th>
              <th width="40%" style={{ color: "#4276a4" }}>
                Số tiền
              </th>
              <th width="25%" style={{ color: "#4276a4" }}>
                Kỳ hạn lãi suất
              </th>
              {/* <th style={{ color: "#4276a4" }}>Ghi chú</th> */}
            </tr>
          </thead>
          {/* {console.log("voucherPaymentMethods", voucherPaymentMethods)} */}
          <tbody>
            {voucherPaymentMethods?.length > 0 &&
              voucherPaymentMethods?.map((el, index) => (
                <>
                  <tr key={index}>
                    <td>
                      <div className="flex align-center gap-2">
                        <div className="flex align-center">
                          {editable &&
                            el?.paymentMethodValue?.characteristic !==
                            PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD &&
                            el?.paymentMethodValue?.characteristic !==
                            PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT &&
                            el?.paymentMethodValue?.code !==
                            PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE &&
                            el?.paymentMethodValue?.code !==
                            PAYMENT_METHOD_CHARACTERISTIC_LOYALTY && (
                              <GlobitsRadioButton
                                name={"totalRadio"}
                                value={el + 1}
                                type="radio"
                                checked={values?.totalRadio === index + 1}
                                onChange={(e) => {
                                  // kiểm tra nếu có tiền cọc or thẻ thì phải clear trc khi gộp tiền
                                  const isCheckMoneyHasDepositOrCard =
                                    handleCheckMoneyHasDepositOrCard();

                                  if (isCheckMoneyHasDepositOrCard) {
                                    toast.warning(
                                      "Vui lòng xóa tiền cọc hoặc thẻ để thao tác gộp tiền"
                                    );
                                    return;
                                  } else {
                                    setFieldValue("totalRadio", index + 1);

                                    let voucherPaymentMethodsFormat =
                                      voucherPaymentMethods?.map((el, stt) => {
                                        if (stt === index) {
                                          return {
                                            ...el,
                                            totalOfMethod:
                                              values?.moneyAfterDiscount,
                                          };
                                        } else {
                                          return {
                                            ...el,
                                            totalOfMethod: 0,
                                            interestRateType: null,
                                            interestRate: 0,
                                            periodMonths: 0,
                                            interestRatePeriodId: null,
                                          };
                                        }
                                      });
                                    setFieldValue(
                                      "voucherPaymentMethods",
                                      voucherPaymentMethodsFormat
                                    );

                                    if (
                                      el?.paymentMethodValue?.characteristic ===
                                      PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
                                    ) {
                                      setFieldValue(
                                        withNameSpace("paymentBank", index),
                                        listStk?.[0]
                                      );
                                      setFieldValue(
                                        withNameSpace(
                                          "bankAccountNumber",
                                          index
                                        ),
                                        listStk?.[0]?.property
                                      );
                                      setFieldValue(
                                        withNameSpace("bankName", index),
                                        listStk?.[0]?.propertyName
                                      );
                                    }
                                    if (
                                      el?.paymentMethodValue?.characteristic ===
                                      PAYMENT_METHOD_CHARACTERISTIC_POS
                                    ) {
                                      setFieldValue(
                                        withNameSpace("paymentBank", index),
                                        listPos?.[0]
                                      );
                                      setFieldValue(
                                        withNameSpace(
                                          "bankAccountNumber",
                                          index
                                        ),
                                        listPos?.[0]?.property
                                      );
                                      setFieldValue(
                                        withNameSpace("bankName", index),
                                        listPos?.[0]?.propertyName
                                      );
                                    }

                                    if (
                                      el?.paymentMethodValue?.characteristic ===
                                      PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP
                                    ) {
                                      setFieldValue(
                                        withNameSpace("paymentBank", index),
                                        listPos_tragop?.[0]
                                      );
                                      setFieldValue(
                                        withNameSpace(
                                          "bankAccountNumber",
                                          index
                                        ),
                                        listPos_tragop?.[0]?.property
                                      );
                                      setFieldValue(
                                        withNameSpace("bankName", index),
                                        listPos_tragop?.[0]?.propertyName
                                      );
                                    }
                                    if (
                                      el?.paymentMethodValue?.characteristic ===
                                      PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT
                                    ) {
                                      setFieldValue(
                                        withNameSpace("paymentBank", index),
                                        listHomecredit?.[0]
                                      );
                                      setFieldValue(
                                        withNameSpace(
                                          "bankAccountNumber",
                                          index
                                        ),
                                        listHomecredit?.[0]?.property
                                      );
                                      setFieldValue(
                                        withNameSpace("bankName", index),
                                        listHomecredit?.[0]?.propertyName
                                      );
                                    }
                                  }
                                }}
                              />
                            )}

                          {el?.paymentMethodValue?.name}
                        </div>

                        {(!el?.totalOfMethod || el?.totalOfMethod == 0) &&
                          el?.paymentMethodValue?.characteristic === // the
                          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD && (
                            <IconCardSelect
                              patientId={patientId}
                              values={values}
                              editable={editable}
                            />
                          )}

                        {(!el?.totalOfMethod || el?.totalOfMethod == 0) &&
                          el?.paymentMethodValue?.characteristic === // ghi no
                          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT && (
                            <IconDepositSelect
                              patientId={patientId}
                              values={values}
                            />
                          )}

                        {el?.totalOfMethod > 0 &&
                          (el?.paymentMethodValue?.characteristic === // the
                            PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD ||
                            el?.paymentMethodValue?.characteristic === // the
                            PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT ||
                            el?.paymentMethodValue?.code === //tien khau tru
                            PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE ||
                            el?.paymentMethodValue?.code === //tien dung diem
                            PAYMENT_METHOD_CHARACTERISTIC_LOYALTY) && (
                            <IconRefreshMoney
                              value={el}
                              values={values}
                              setFieldValue={setFieldValue}
                              index={index}
                              voucherPaymentMethods={voucherPaymentMethods}
                              listStk={listStk}
                            />
                          )}

                        {(!el?.totalOfMethod || el?.totalOfMethod == 0) &&
                          el?.paymentMethodValue?.code === //tien khau tru
                          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE && (
                            <IconTreatmentRetainSelect
                              patientId={patientId}
                              values={values}
                            />
                          )}

                        {(!el?.totalOfMethod || el?.totalOfMethod == 0) &&
                          el?.paymentMethodValue?.code === //tien dung diem
                          PAYMENT_METHOD_CHARACTERISTIC_LOYALTY && (
                            <IconLoyaltySelect
                              patientId={patientId}
                              values={values}
                            />
                          )}
                      </div>
                    </td>

                    <td>
                      <GlobitsVNDCurrencyInput
                        name={withNameSpace("totalOfMethod", index)}
                        disabled={
                          // !editable &&
                          el?.paymentMethodValue?.characteristic ===
                          PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD ||
                          el?.paymentMethodValue?.characteristic ===
                          PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT ||
                          el?.paymentMethodValue?.characteristic ===
                          PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT ||
                          el?.paymentMethodValue?.code ===
                          PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE ||
                          el?.paymentMethodValue?.code ===
                          PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
                        }
                        onChange={(e) =>
                          handleChangeTotalOfMethod(e, el, index)
                        }
                      // notDelay
                      />
                    </td>

                    <td>
                      {/* chọn kỳ hạn lãi xuất theo hình thức thanh toán */}
                      {(el?.interestRatePeriods?.length > 0 ||
                        el?.paymentMethodValue?.interestRatePeriods?.length > 0 ||
                        PAYMENT_METHOD_CODES_REQUIRED_INTEREST_RATE?.includes(
                          el?.paymentMethodValue?.code
                        )) &&
                        getIn(values, withNameSpace("totalOfMethod", index)) > 0 && (
                          <IconInterestRateSelect
                            index={index}
                            paymentMethod={el?.paymentMethodValue || el}
                            totalOfMethod={getIn(values, withNameSpace("totalOfMethod", index))}
                            nameSpace={nameSpace}
                            parentValues={values}
                            setParentFieldValue={setFieldValue}
                          />
                        )}
                      {(() => {
                        const selectedInterest = getIn(values, `${nameSpace}[${index}]`);
                        if (!selectedInterest || selectedInterest.interestRateType == null) return null;

                        const typeObj = INTEREST_RATE_TYPE.find(t => t.value === selectedInterest.interestRateType);
                        if (!typeObj) return null;

                        let displayStr = typeObj.name;
                        if (selectedInterest.periodMonths != null) {
                          displayStr += ` - Kỳ hạn ${selectedInterest.periodMonths} tháng`;
                        }
                        if (selectedInterest.interestRate != null) {
                          displayStr += ` - Lãi suất ${selectedInterest.interestRate}%`;
                        }
                          return displayStr;
                        })()}
                        {getIn(errors, `${nameSpace}[${index}].interestRatePeriodId`) && (
                          <div className="text-red">
                            {getIn(errors, `${nameSpace}[${index}].interestRatePeriodId`)}
                          </div>
                        )}
                      </td>
                  </tr>

                  {el?.paymentMethodValue?.characteristic ===
                    PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT &&
                    getIn(values, withNameSpace("totalOfMethod", index)) !=
                    0 && (
                      <tr>
                        <td colSpan={3}>
                          <GlobitsPagingAutocomplete
                            disabled={!editable}
                            placeholder="Chọn stk"
                            name={withNameSpace("paymentBank", index)}
                            api={pagingExtGlobalProperty}
                            searchObject={{
                              isActive: true,
                              dataType: TYPE_GLOBAL_PROPOTIES_BANK,
                              departmentIds: values?.department
                                ? [values?.department.id]
                                : [],
                            }}
                            getOptionLabel={(option) => {
                              return `${option?.propertyName} - ${option?.property}`;
                            }}
                            onChange={(_, value) => {
                              setFieldValue(
                                withNameSpace("paymentBank", index),
                                value
                              );
                              setFieldValue(
                                withNameSpace("bankAccountNumber", index),
                                value?.property
                              );
                              setFieldValue(
                                withNameSpace("bankName", index),
                                value?.propertyName
                              );
                            }}
                          />
                        </td>
                      </tr>
                    )}

                  {el?.paymentMethodValue?.characteristic ===
                    PAYMENT_METHOD_CHARACTERISTIC_POS &&
                    getIn(values, withNameSpace("totalOfMethod", index)) !=
                    0 && (
                      <tr>
                        <td colSpan={3}>
                          <GlobitsPagingAutocomplete
                            disabled={!editable}
                            placeholder="Chọn máy pos"
                            name={withNameSpace("paymentBank", index)}
                            api={pagingExtGlobalProperty}
                            searchObject={{
                              isActive: true,
                              dataType: TYPE_GLOBAL_PROPOTIES_POS_LIST,
                              departmentIds: values?.department
                                ? [values?.department.id]
                                : [],
                            }}
                            getOptionLabel={(option) => {
                              return `${option?.propertyName} - ${option?.property}`;
                            }}
                            onChange={(_, value) => {
                              setFieldValue(
                                withNameSpace("paymentBank", index),
                                value
                              );
                              setFieldValue(
                                withNameSpace("bankAccountNumber", index),
                                value?.property
                              );
                              setFieldValue(
                                withNameSpace("bankName", index),
                                value?.propertyName
                              );
                            }}
                          />
                        </td>
                      </tr>
                    )}

                  {el?.paymentMethodValue?.characteristic ===
                    PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT &&
                    getIn(values, withNameSpace("totalOfMethod", index)) !=
                    0 && (
                      <tr>
                        <td colSpan={2}>
                          <GlobitsPagingAutocomplete
                            disabled={!editable}
                            placeholder="Chọn home credit"
                            name={withNameSpace("paymentBank", index)}
                            api={pagingExtGlobalProperty}
                            searchObject={{
                              isActive: true,
                              dataType: TYPE_GLOBAL_PROPOTIES_HOME_CREDIT_CODE,
                              departmentIds: values?.department
                                ? [values?.department.id]
                                : [],
                            }}
                            getOptionLabel={(option) => {
                              return `${option?.propertyName} - ${option?.property}`;
                            }}
                            onChange={(_, value) => {
                              setFieldValue(
                                withNameSpace("paymentBank", index),
                                value
                              );
                              setFieldValue(
                                withNameSpace("bankAccountNumber", index),
                                value?.property
                              );
                              setFieldValue(
                                withNameSpace("bankName", index),
                                value?.propertyName
                              );
                            }}
                          />
                        </td>
                      </tr>
                    )}

                  {el?.paymentMethodValue?.characteristic ===
                    PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP &&
                    getIn(values, withNameSpace("totalOfMethod", index)) !=
                    0 && (
                      <tr>
                        <td colSpan={2}>
                          <GlobitsPagingAutocomplete
                            disabled={!editable}
                            placeholder="Chọn máy pos vnpay trả góp"
                            name={withNameSpace("paymentBank", index)}
                            api={pagingExtGlobalProperty}
                            searchObject={{
                              isActive: true,
                              dataType: TYPE_GLOBAL_PROPOTIES_POS_VNPAY_TRAGOP,
                              departmentIds: values?.department
                                ? [values?.department.id]
                                : [],
                            }}
                            getOptionLabel={(option) => {
                              return `${option?.propertyName} - ${option?.property}`;
                            }}
                            onChange={(_, value) => {
                              setFieldValue(
                                withNameSpace("paymentBank", index),
                                value
                              );
                              setFieldValue(
                                withNameSpace("bankAccountNumber", index),
                                value?.property
                              );
                              setFieldValue(
                                withNameSpace("bankName", index),
                                value?.propertyName
                              );
                            }}
                          />
                        </td>
                      </tr>
                    )}
                </>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
const IconRefreshMoney = observer(
  ({ value, values, setFieldValue, listStk, index, voucherPaymentMethods }) => {
    const {
      handleOpenRefreshCardFee,
      openRefreshCardFee,
      handleCloseConfirmRefreshCardFee,
      handleConfirmRefreshCardFee,
    } = useStore().feeStore.serviceFeeTabStore;

    let title = "";
    if (
      openRefreshCardFee?.paymentMethodValue?.code ===
      PAYMENT_METHOD_CHARACTERISTIC_TREATMENT_PLANTCARD_CODE
    ) {
      title = "khấu trừ liệu trình cũ";
    } else if (
      openRefreshCardFee?.paymentMethodValue?.characteristic ===
      PAYMENT_METHOD_CHARACTERISTIC_DEDUCT_FROM_DEPOSIT
    ) {
      title = "cọc";
    } else if (
      openRefreshCardFee?.paymentMethodValue?.characteristic ===
      PAYMENT_METHOD_CHARACTERISTIC_USE_PREPAID_CARD
    ) {
      title = "thẻ";
    } else if (
      openRefreshCardFee?.paymentMethodValue?.code ===
      PAYMENT_METHOD_CHARACTERISTIC_LOYALTY
    ) {
      title = "điểm";
    }

    return (
      <div className="flex flex-center">
        <Tooltip title="Bỏ tiền">
          <div
            onClick={() => {
              handleOpenRefreshCardFee({ ...value, index });
            }}
          >
            <IconClose color="red" />
          </div>
        </Tooltip>
        {openRefreshCardFee && openRefreshCardFee?.index === index && (
          <ConfirmPopup
            open={openRefreshCardFee}
            onClose={() => handleCloseConfirmRefreshCardFee(null)}
            text={`Bạn có chắc chắn muốn hủy dùng tiền ${title} này không ?`}
            onConfirm={async () => {
              let voucherPaymentMethodsFormat = voucherPaymentMethods?.map(
                (el, ind) => {
                  if (openRefreshCardFee?.index === ind) {
                    return {
                      ...el,
                      totalOfMethod: 0,
                      interestRateType: null,
                      interestRate: 0,
                      periodMonths: 0,
                      interestRatePeriodId: null,
                    };
                  } else if (
                    el?.paymentMethodValue?.characteristic ===
                    PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT
                  ) {
                    return {
                      ...el,
                      totalOfMethod:
                        el?.totalOfMethod + +openRefreshCardFee?.totalOfMethod,
                    };
                  } else {
                    return {
                      ...el,
                      totalOfMethod: el?.totalOfMethod ? el?.totalOfMethod : 0,
                    };
                  }
                }
              );
              await setFieldValue(
                "voucherPaymentMethods",
                voucherPaymentMethodsFormat
              );

              await handleConfirmRefreshCardFee({
                ...values,
                voucherPaymentMethods: voucherPaymentMethodsFormat,
              });
            }}
          />
        )}
      </div>
    );
  }
);

const IconCardSelect = observer(({ patientId, values, editable }) => {
  const {
    handleOpenClientCardUpdateFeePopup,
    openClientCardFeePopup,
    handleCloseClientCardFeePopup,
    initialValueCardFee,
    handleInitCardItemsAndServiceItems,
    handleSubmitTransactionCardPopupUpdate,
  } = useStore().feeStore.serviceFeeTabStore;
  return (
    <div className="flex flex-center">
      <Tooltip title="Chọn thẻ">
        <div
          onClick={() => {
            if (editable) {
              handleOpenClientCardUpdateFeePopup({ ...values, patientId });
            }
          }}
        >
          <TouchAppIcon color="primary" />
        </div>
      </Tooltip>
      {openClientCardFeePopup && (
        <SelectCardFeePopup
          open={openClientCardFeePopup}
          handleClose={handleCloseClientCardFeePopup}
          initialValueCardFee={initialValueCardFee}
          handleInitCardItemsAndServiceItems={
            handleInitCardItemsAndServiceItems
          }
          handleSubmit={handleSubmitTransactionCardPopupUpdate}
        />
      )}
    </div>
  );
});

const IconDepositSelect = observer(({ patientId, values }) => {
  const {
    handleOpenDepositMoneyFeePopupUpdate,
    openDepositMoneyFeePopup,
    handleCloseDepositMoneyFeePopup,
    initialValueDepositMoneyFee,
    handleSubmitTransactionDepositMoneyPopupUpdate,
    handleInitAdvanceMoneyTransaction,
  } = useStore().feeStore.serviceFeeTabStore;

  return (
    <div className="flex flex-center">
      <Tooltip title="Chọn tiền cọc">
        <div
          onClick={() => {
            handleOpenDepositMoneyFeePopupUpdate({ ...values, patientId });
          }}
        >
          <TouchAppIcon color="primary" />
        </div>
      </Tooltip>
      {openDepositMoneyFeePopup && (
        <SelectDepositMoneyFeePopup
          open={openDepositMoneyFeePopup}
          handleClose={handleCloseDepositMoneyFeePopup}
          handleSubmit={handleSubmitTransactionDepositMoneyPopupUpdate}
          handleInitAdvanceMoneyTransaction={handleInitAdvanceMoneyTransaction}
          initialValueDepositMoneyFee={initialValueDepositMoneyFee}
        />
      )}
    </div>
  );
});

const IconTreatmentRetainSelect = observer(({ patientId, values }) => {
  const {
    handleOpenTreatmentRetainFeePopupUpdate,
    openTreatmentRetainFeePopup,
    handleCloseTreatmentRetainFeePopup,
    initialValueTreatmentRetainFee,
    handleSubmitTransactionTreatmentRetainUpdate,
    handleInitTreatmentRetainTransactionUpdate,
  } = useStore().feeStore.serviceFeeTabStore;

  return (
    <div className="flex flex-center">
      <Tooltip title="Chọn Khấu trừ tiền LT cũ">
        <div
          onClick={() => {
            handleOpenTreatmentRetainFeePopupUpdate({ ...values, patientId });
          }}
        >
          <TouchAppIcon color="primary" />
        </div>
      </Tooltip>
      {openTreatmentRetainFeePopup && (
        <SelectTreatmentRetainPopup
          open={openTreatmentRetainFeePopup}
          handleClose={handleCloseTreatmentRetainFeePopup}
          handleSubmit={handleSubmitTransactionTreatmentRetainUpdate}
          handleInitTreatmentRetainTransaction={
            handleInitTreatmentRetainTransactionUpdate
          }
          initialValueTreatmentRetainFee={initialValueTreatmentRetainFee}
        />
      )}
    </div>
  );
});

const IconLoyaltySelect = observer(({ patientId, values }) => {
  const {
    handleOpenLoyaltyPointPopupUpdate,
    openLoyaltyPointFeePopup,
    handleCloseLoyaltyPointFeePopup,
    initialValueLoyaltyPointFee,
    handleSubmitLoyaltyPointUpdate,
    handleInitLoyaltyPoint,
  } = useStore().feeStore.serviceFeeTabStore;

  return (
    <div className="flex flex-center">
      <Tooltip title="Chọn điểm khách hàng">
        <div
          onClick={() => {
            handleOpenLoyaltyPointPopupUpdate({ ...values, patientId });
          }}
        >
          <TouchAppIcon color="primary" />
        </div>
      </Tooltip>
      {openLoyaltyPointFeePopup && (
        <SelectLoyaltyPointPopup
          open={openLoyaltyPointFeePopup}
          handleClose={handleCloseLoyaltyPointFeePopup}
          handleSubmit={handleSubmitLoyaltyPointUpdate}
          handleInitLoyaltyPoint={handleInitLoyaltyPoint}
          initialValueLoyaltyPointFee={initialValueLoyaltyPointFee}
        />
      )}
    </div>
  );
});

// nút ấn mở popup kỳ hạn lãi suất
const IconInterestRateSelect = observer(({ index, paymentMethod, totalOfMethod, nameSpace, parentValues, setParentFieldValue }) => {
  const [open, setOpen] = React.useState(false);

  return (
    <div className="flex flex-center ml-1">
      <Tooltip title="Thông tin lãi suất">
        <div onClick={() => setOpen(true)}>
          <TouchAppIcon style={{ color: "#ff9800" }} />
        </div>
      </Tooltip>
      {open && (
        <SelectInterestRatePopup
          open={open}
          handleClose={() => setOpen(false)}
          paymentMethod={paymentMethod}
          totalOfMethod={totalOfMethod}
          item={getIn(parentValues, `${nameSpace}[${index}]`)}
          onSave={(localValues) => {
            const basePath = `${nameSpace}[${index}]`;
            const currentItem = getIn(parentValues, basePath);
            const newItem = {
              ...currentItem,
              interestRateType: localValues.interestRateType,
              interestRate: localValues.interestRate,
              periodMonths: localValues.periodMonths,
              interestRatePeriodId: localValues.interestRatePeriodId,
            };
            setParentFieldValue(basePath, newItem);
          }}
        />
      )}
    </div>
  );
});

export default memo(observer(TotalOfVoucherByUpdate));
